// // @mui
// import Stack from '@mui/material/Stack';
// import Skeleton from '@mui/material/Skeleton';
// import TableCell from '@mui/material/TableCell';
// import TableRow from '@mui/material/TableRow';

// // ----------------------------------------------------------------------

// export default function TableSkeleton({ ...other }) {
//   return (
//     <TableRow {...other}>
//       <TableCell colSpan={12}>
//         <Stack spacing={3} direction="row" alignItems="center">
//           <Skeleton sx={{ borderRadius: 1.5, width: 48, height: 48, flexShrink: 0 }} />
//           <Skeleton sx={{ width: 1, height: 12 }} />
//           <Skeleton sx={{ width: 180, height: 12 }} />
//           <Skeleton sx={{ width: 160, height: 12 }} />
//           <Skeleton sx={{ width: 140, height: 12 }} />
//           <Skeleton sx={{ width: 120, height: 12 }} />
//         </Stack>
//       </TableCell>
//     </TableRow>
//   );
// }


import React from 'react';
import PropTypes from "prop-types";
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export default function TableSkeleton({ columns }) {
  return (
    <TableRow>
      {columns.map((column, index) => (
        <TableCell key={index} sx={{ width: column.width || 'auto', minWidth: column.minWidth ,height: 'auto', minHeight: 50 }}>
          <Skeleton variant="rectangular" width="100%" height={30} sx={{borderRadius: "5px"}}  />
        </TableCell>
      ))}
    </TableRow>
  );
}

TableSkeleton.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Width can be a string (e.g., "auto") or a number (e.g., 150)
    })
  ).isRequired,
};
